import request from '@/utils/request'

// 停止单个公众号推送
export function stopOneSend(data = {}) {
  return request({
    url: '/timingPushArtc/stopOneSend',
    method: 'post',
    data
  })
}
// 脚本推送（客户）
export function wwScriptJobuserMessageRecord(params = {}) {
  return request({
    url: '/spWorkWechat/wwScriptJob/userMessageRecord',
    method: 'get',
    params
  })
}
// otaphone升级列表
export function otalist(params) {
  return request({
    url: '/wwScript/getOtaList',
    method: 'get',
    params
  })
}
// otaphone升级下发
export function issuedota(data) {
  return request({
    url: '/wwScript/upgradeSend',
    method: 'post',
    data
  })
}
// otaphone功能配置添加
export function createOtaConfig(data) {
  return request({
    url: '/wwScript/createOtaConfig',
    method: 'post',
    data
  })
}
// otaphone升级创建
export function createOta(data) {
  return request({
    url: '/wwScript/createOta',
    method: 'post',
    data
  })
}
// otaphone升级修改
export function updataOta(data) {
  return request({
    url: '/wwScript/updateOta',
    method: 'post',
    data
  })
}
// otaphone功能配置列表
export function getOtaConfigList(params) {
  return request({
    url: '/wwScript/getOtaConfigList',
    method: 'get',
    params
  })
}
// 上传商户号的证书文件
export function uploadForWwOta(data) {
  return request({
    url: '/qcloud/uploadForWwOta',
    method: 'post',
    data,
    isUpload: true
  })
}
// otaphone升级修改
export function wwScriptdelOta(data) {
  return request({
    url: '/wwScript/delOta',
    method: 'post',
    data
  })
}
// otaphone绑定手机列表
export function phonelistForUpgrade(params) {
  return request({
    url: '/workWechat/phone/listForUpgrade',
    method: 'get',
    params
  })
}
// 发送记录（用户详情）
export function userMessageRecordDetail(params) {
  return request({
    url: '/spWorkWechat/wwScriptJob/userMessageRecordDetail',
    method: 'get',
    params
  })
}
// 发送记录（群）
export function wwScriptJobgroupMessageRecord(params) {
  return request({
    url: '/spWorkWechat/wwScriptJob/groupMessageRecord',
    method: 'get',
    params
  })
}
// 发送记录（群详情）
export function wwScriptJobgroupMessageRecordDetail(params) {
  return request({
    url: '/spWorkWechat/wwScriptJob/groupMessageRecordDetail',
    method: 'get',
    params
  })
}
// 发送记录新（用户详情）
export function strategyscriptPushRecordDetail(params) {
  return request({
    url: '/spWorkWechat/strategy/scriptPushRecordDetail',
    method: 'get',
    params
  })
}
// 策略罗盘
export function strategyPanelofficialSentResult(data) {
  return request({
    url: '/spWorkWechat/strategyPanel/officialSentResult',
    method: 'post',
    data
  })
}
